module.exports = __webpack_public_path__ + "img/bum(1).087e6648.jpg";